module.exports = {"Type":"Message","Output":true,"Fields":[{"label":"Message","type":"multiline","name":"text","serializeTo":"q"},{"label":"Speak","type":"multiline","name":"speak"},{"label":"Publisher visibility","type":"yesno","name":"publisher","defaultValue":"No"}],"Header":{"Color":"black","BackgroundColor":"#e0e0e0","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Message.json
// module id = 665
// module chunks = 0